export interface Tomo {
  number: string
  short: string
  title: string
  detail: string
  spine: string
}

export const tomos: Tomo[] = [
  {
    number: '01',
    short: 'Desinflamación',
    title: 'El Protocolo de Emergencia: 21 Días de Desinflamación',
    detail:
      'Plan paso a paso para bajar inflamación rápido. Qué comer, qué evitar y por qué funciona. Resultados visibles en 3 semanas.',
    spine: 'bg-blue-600',
  },
  {
    number: '02',
    short: 'Recetario',
    title: 'Combustible Metabólico: Recetario Anti-Cortisol',
    detail:
      '70 recetas simples adaptadas a los 45+. Comé de verdad, sin pasar hambre, estabilizando tu energía todo el día.',
    spine: 'bg-blue-700',
  },
  {
    number: '03',
    short: 'Suplementos',
    title: 'El Botiquín Hormonal: Guía Maestra de Suplementos',
    detail: 'Qué tomar, cuándo, por qué y dónde. Sin confusión. Sin gastar en cosas que no necesitás.',
    spine: 'bg-blue-800',
  },
  {
    number: '04',
    short: 'Decodificación',
    title: 'Manual de Decodificación: Entendiendo tu Nuevo Idioma Hormonal',
    detail:
      'Por qué se hincha tu abdomen. Por qué no dormís. Por qué se te olvidan cosas. Traducción de cada síntoma.',
    spine: 'bg-blue-900',
  },
  {
    number: '05',
    short: 'Saboteadores',
    title: 'Saboteadores Ocultos: Limpieza de Falsas Hormonas',
    detail:
      'Químicos en tu casa que boicotean tu metabolismo. Checklist de qué cambiar y por dónde empezar.',
    spine: 'bg-blue-700',
  },
  {
    number: '06',
    short: 'Sueño y calma',
    title: 'El Interruptor del Descanso: Protocolo de Sueño y Calma',
    detail:
      'Apagar el sistema de alerta. Rutina nocturna científica. Recuperar el sueño que necesitás.',
    spine: 'bg-blue-800',
  },
]

export type PillarIcon = 'protocol' | 'nutrition' | 'supplements' | 'signals'

export interface Pillar {
  icon: PillarIcon
  title: string
  description: string
}

export const pillars: Pillar[] = [
  {
    icon: 'protocol',
    title: 'Desinflamación en 21 días',
    description:
      'Protocolo choque: plan claro de comidas, qué evitar y qué tomar para bajar la inflamación rápido.',
  },
  {
    icon: 'nutrition',
    title: 'Nutrición adaptada a los 45+',
    description:
      'No es una dieta. Es aprender a comer de forma que tu cuerpo se sienta seguro y suelte el peso.',
  },
  {
    icon: 'supplements',
    title: 'Suplementación inteligente',
    description:
      'Guía clara de qué suplementos pueden ayudar en esta etapa, sin abrumar ni gastar de más.',
  },
  {
    icon: 'signals',
    title: 'Decodificador de señales',
    description:
      'Entendé qué te dice tu cuerpo cuando se hincha, cuando te despierta, cuando se irrita. Dejá de adivinar.',
  },
]

export interface Bonus {
  tag: string
  title: string
  description: string
  value: string
}

export const bonuses: Bonus[] = [
  {
    tag: 'Bono 1',
    title: 'Decodificador BIO-RESET 45+',
    description:
      'Test de 7 minutos para descubrir qué necesita tu cuerpo primero: desinflamación, energía, sueño o claridad.',
    value: '$4.500',
  },
  {
    tag: 'Bono 2',
    title: 'Mapa de Arranque 72 Horas',
    description:
      'Plan simple de 3 días para dejar de improvisar y empezar con dirección clara desde el primer día.',
    value: '$5.000',
  },
  {
    tag: 'Bono 3',
    title: 'Lista de Compras BIO-RESET',
    description:
      'Sabé exactamente qué comprar en el súper sin improvisar. Separado por categorías, con semáforo de alimentos.',
    value: '$3.500',
  },
  {
    tag: 'Bono 4',
    title: 'Diario Detective de Señales',
    description:
      'Workbook de 14 días para descubrir qué te hincha, qué te apaga y qué te devuelve energía realmente.',
    value: '$6.000',
  },
  {
    tag: 'Bono 5',
    title: 'Guía SOS: Qué Hago Cuando...',
    description:
      'Protocolos de rescate de 5 minutos para esos momentos de hinchazón, ansiedad, insomnio o bajón.',
    value: '$5.500',
  },
  {
    tag: 'Bono 6',
    title: 'Script de Consulta Inteligente 45+',
    description:
      'Llegá a tu próxima consulta médica con claridad. Frases, checklist y preguntas listas.',
    value: '$4.000',
  },
]

export const bonusesTotalValue = '$28.500'

export interface PainPoint {
  title: string
  description: string
}

export const painPoints: PainPoint[] = [
  {
    title: 'Te inflamás sin motivo',
    description: 'Comés normal y tu abdomen se hincha como globo. No es culpa tuya, es tu cuerpo hablándote.',
  },
  {
    title: 'Dormís peor que antes',
    description: 'Te despertás a las 3 AM con calor, ansiedad o sin saber por qué no dormís como antes.',
  },
  {
    title: 'Sentís "neblina mental"',
    description:
      'Se te olvidan cosas simples, te cuesta concentrarte y sentís que tu mente no es la de antes.',
  },
  {
    title: 'Ya no te reconocés',
    description:
      'Te mirás al espejo y sentís que la mujer que ves no es la de hace 10 años. Te asusta.',
  },
  {
    title: 'Te cansa todo',
    description: 'Aunque duermas, te sentís agotada. La energía de antes desapareció sin aviso.',
  },
  {
    title: 'Tu médico dice "es normal"',
    description:
      'Pero a vos no te parece normal. Querés soluciones prácticas, no que todo se normalice.',
  },
]

export interface ShortQuote {
  initials: string
  quote: string
  author: string
  city: string
}

export const heroQuotes: ShortQuote[] = [
  {
    initials: 'CM',
    quote: 'En 3 semanas me vi diferente. La panza se desinchó y volví a reconocerme.',
    author: 'Claudia M.',
    city: 'Rosario',
  },
  {
    initials: 'PL',
    quote: 'Por fin alguien que entiende qué me está pasando. El manual de decodificación me cambió la vida.',
    author: 'Patricia L.',
    city: 'CABA',
  },
  {
    initials: 'DS',
    quote: 'Ya no me siento invisible. Tengo un plan, tengo control y duermo mejor.',
    author: 'Daniela S.',
    city: 'Mendoza',
  },
]

export const deepQuotes: ShortQuote[] = [
  {
    initials: 'AG',
    quote:
      'Pasé de sentirme perdida a tener un mapa claro. El manual de decodificación me explicó todo lo que mi médico no entendía.',
    author: 'Alejandra G.',
    city: 'Córdoba',
  },
  {
    initials: 'MT',
    quote:
      'En 21 días bajé 2 kg, pero más importante: recuperé mi mente. No tengo esa neblina mental de antes.',
    author: 'Marcela T.',
    city: 'La Plata',
  },
  {
    initials: 'SM',
    quote:
      'Finalmente una solución que se adapta a mí. Los protocolos son simples, lógicos y funcionan desde el primer día.',
    author: 'Silvia M.',
    city: 'Rosario',
  },
  {
    initials: 'CS',
    quote:
      'Duermo mejor, me levanto sin ansiedad y mi familia nota que soy más paciente. Todo cambió rápido.',
    author: 'Carolina S.',
    city: 'CABA',
  },
  {
    initials: 'PR',
    quote: 'No es solo sobre bajar peso. Es sobre recuperar tu identidad. Ahora me reconozco al espejo.',
    author: 'Patricia R.',
    city: 'Mendoza',
  },
  {
    initials: 'EL',
    quote:
      'Los bonos de rescate son oro. Cuando me hincho o me agarra ansiedad, abro la guía SOS y en 5 minutos me recompongo.',
    author: 'Elena L.',
    city: 'San Juan',
  },
]

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: '¿Funciona a cualquier edad dentro de los 45+?',
    answer:
      'Sí. Funciona desde los 42 años en perimenopausia hasta cualquier edad en menopausia. Cada protocolo se adapta según tu energía y ritmo.',
  },
  {
    question: '¿Necesito experiencia en nutrición o biología?',
    answer:
      'No. Todo está explicado en lenguaje simple. No hay jerga médica. Los tomos están diseñados para que cualquier mujer entienda qué le pasa.',
  },
  {
    question: '¿Cuánto tiempo necesito cada día?',
    answer:
      'Entre 10 y 30 minutos. El Tomo 1 tiene un protocolo de 21 días de 15 minutos diarios. Todo está cronometrado para que sea realista.',
  },
  {
    question: '¿Reemplaza al médico?',
    answer:
      'No. Es un complemento. Te ayuda a entender tu cuerpo y llegar mejor a una consulta médica. Incluye un script para hablar con tu doctor con claridad.',
  },
  {
    question: '¿Tengo que eliminar alimentos para siempre?',
    answer:
      'No. El protocolo de 21 días pausa alimentos inflamatorios para que veas cómo se siente tu cuerpo. Luego vas reintroduciendo según tu tolerancia.',
  },
  {
    question: '¿Es solo para perder peso?',
    answer:
      'No. Es para recuperar identidad, claridad, energía y control. El peso es una consecuencia de sentirse mejor, no el objetivo central.',
  },
  {
    question: '¿En cuánto tiempo veo resultados?',
    answer:
      'El 70% de las mujeres ve cambios en desinflamación, sueño y energía en 7 días. Cambios más profundos aparecen entre 21 y 60 días.',
  },
  {
    question: '¿Puedo acceder desde celular o necesito imprimir?',
    answer:
      'Ambos. Recibís PDFs listos para imprimir o guardar en tu celular. Algunos bonos tienen versión móvil resumida.',
  },
]

export const costWithout: string[] = [
  'Seguís sintiéndote hinchada',
  'Insomnio cada noche',
  'Neblina mental permanente',
  'Pérdida progresiva de energía',
  'Sin claridad de qué hacer',
]

export const costWith: string[] = [
  'Desinflamación en 21 días',
  'Dormís mejor en 7 días',
  'Claridad mental recuperada',
  'Energía estable y consistente',
  'Un sistema ordenado y listo',
  'Resultados en semanas, no meses',
]

export const checkoutUrl = 'https://mi-mejor-version.impultienda.ar'

export interface Offer {
  name: string
  summary: string
  includes: string[]
  listPrice: string
  price: string
  savings: string
  cta: string
}

export const offer: Offer = {
  name: 'MegaPack BIO-RESET 5.0',
  summary: '6 Tomos (sistema completo) + 6 Bonos (herramientas listas para usar)',
  includes: [
    '6 Tomos con el sistema completo BIO-RESET',
    'Protocolo de 21 días de desinflamación',
    '70 recetas anti-cortisol adaptadas a los 45+',
    'Guía maestra de suplementos 45+',
    '6 Bonos listos para usar (valor $28.500)',
    '100% PDF: imprimilo o usalo desde el celular',
  ],
  listPrice: '$51.000',
  price: '$19.990',
  savings: 'Ahorrás $31.010 (61% OFF)',
  cta: 'Quiero mi MegaPack BIO-RESET ahora',
}

export const heroImage = 'https://cdn.magicpatterns.com/uploads/tRkGjuEk7PjpKm3oWYjDNo/image.png'
